var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 52,
    viewBox: "0 0 180 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 52H6.66667C3.00167 52 0 49.0734 0 45.5V6.5C0 2.92663 3.00167 2.74817e-06 6.66667 2.74817e-06H173.333C176.998 2.74817e-06 180 2.92663 180 6.5V45.5C180 49.0734 176.998 52 173.333 52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.333 1.04163C176.42 1.04163 178.932 3.4905 178.932 6.5V45.5C178.932 48.5095 176.42 50.9584 173.333 50.9584H6.66667C3.58 50.9584 1.06833 48.5095 1.06833 45.5V6.5C1.06833 3.4905 3.58 1.04163 6.66667 1.04163H173.333ZM173.333 2.74817e-06H6.66667C3.00167 2.74817e-06 0 2.92663 0 6.5V45.5C0 49.0734 3.00167 52 6.66667 52H173.333C176.998 52 180 49.0734 180 45.5V6.5C180 2.92663 176.998 2.74817e-06 173.333 2.74817e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9133 9.80044C13.5216 10.2002 13.2949 10.8226 13.2949 11.6286V40.3781C13.2949 41.1841 13.5216 41.8064 13.9133 42.2062L14.0099 42.2939L30.5332 26.1902V25.8099L14.0099 9.7062L13.9133 9.80044Z",
    fill: "url(#paint0_linear_476_11409)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0349 31.5605L30.5332 26.1899V25.8097L36.0415 20.439L36.1649 20.5089L42.6882 24.1278C44.5499 25.1548 44.5499 26.8448 42.6882 27.8783L36.1649 31.4907L36.0349 31.5605Z",
    fill: "url(#paint1_linear_476_11409)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1647 31.4907L30.5331 25.9998L13.9131 42.206C14.5314 42.8397 15.5398 42.9161 16.6864 42.2823L36.1647 31.4907Z",
    fill: "url(#paint2_linear_476_11409)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1647 20.5091L16.6864 9.71751C15.5398 9.09025 14.5314 9.16663 13.9131 9.80038L30.5331 26L36.1647 20.5091Z",
    fill: "url(#paint3_linear_476_11409)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2234 13.3172C63.2234 14.4027 62.8901 15.2721 62.2334 15.9204C61.4784 16.6891 60.4951 17.0758 59.2901 17.0758C58.1384 17.0758 57.155 16.6826 56.3484 15.9074C55.54 15.1209 55.1367 14.1557 55.1367 13.0003C55.1367 11.8449 55.54 10.8797 56.3484 10.0997C57.155 9.31806 58.1384 8.9248 59.2901 8.9248C59.8634 8.9248 60.41 9.04018 60.9317 9.25468C61.4517 9.4708 61.875 9.7633 62.1817 10.1241L61.4851 10.8098C60.95 10.1939 60.2217 9.89006 59.2901 9.89006C58.4501 9.89006 57.7217 10.1761 57.1034 10.7529C56.4917 11.3314 56.185 12.0806 56.185 13.0003C56.185 13.9201 56.4917 14.6757 57.1034 15.2542C57.7217 15.8246 58.4501 16.1171 59.2901 16.1171C60.1817 16.1171 60.9317 15.8246 61.5234 15.2477C61.9134 14.8658 62.1351 14.3393 62.1934 13.6666H59.2901V12.7273H63.1634C63.2101 12.9304 63.2234 13.1271 63.2234 13.3172Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3685 10.0606H65.7302V12.5306H69.0102V13.4699H65.7302V15.9399H69.3685V16.897H64.7002V9.10352H69.3685V10.0606Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.705 16.897H72.675V10.0606H70.4434V9.10352H75.9384V10.0606H73.705V16.897Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.915 16.897V9.10352H80.9434V16.897H79.915Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5019 16.897H84.4802V10.0606H82.2402V9.10352H87.7419V10.0606H85.5019V16.897Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1446 15.8944C97.3563 16.6826 96.3796 17.0758 95.2146 17.0758C94.0429 17.0758 93.0663 16.6826 92.2779 15.8944C91.4913 15.1079 91.0996 14.1427 91.0996 13.0003C91.0996 11.8579 91.4913 10.8927 92.2779 10.1062C93.0663 9.31805 94.0429 8.9248 95.2146 8.9248C96.3729 8.9248 97.3496 9.31805 98.138 10.1127C98.9313 10.9057 99.3229 11.8644 99.3229 13.0003C99.3229 14.1427 98.9313 15.1079 98.1446 15.8944ZM93.0396 15.2412C93.6329 15.8246 94.3546 16.1171 95.2146 16.1171C96.0679 16.1171 96.7963 15.8246 97.3829 15.2412C97.9746 14.6578 98.2746 13.9087 98.2746 13.0003C98.2746 12.0919 97.9746 11.3428 97.3829 10.7594C96.7963 10.1761 96.0679 9.88355 95.2146 9.88355C94.3546 9.88355 93.6329 10.1761 93.0396 10.7594C92.4479 11.3428 92.1479 12.0919 92.1479 13.0003C92.1479 13.9087 92.4479 14.6578 93.0396 15.2412Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.769 16.897V9.10352H102.019L105.905 15.1648H105.95L105.905 13.6665V9.10352H106.934V16.897H105.86L101.79 10.5368H101.745L101.79 12.0415V16.897H100.769Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8464 28.2783C87.7147 28.2783 85.1564 30.602 85.1564 33.8082C85.1564 36.9883 87.7147 39.3364 90.8464 39.3364C93.9847 39.3364 96.543 36.9883 96.543 33.8082C96.543 30.602 93.9847 28.2783 90.8464 28.2783ZM90.8464 37.1589C89.128 37.1589 87.6497 35.776 87.6497 33.8082C87.6497 31.8143 89.128 30.4558 90.8464 30.4558C92.5647 30.4558 94.0497 31.8143 94.0497 33.8082C94.0497 35.776 92.5647 37.1589 90.8464 37.1589ZM78.4314 28.2783C75.293 28.2783 72.7414 30.602 72.7414 33.8082C72.7414 36.9883 75.293 39.3364 78.4314 39.3364C81.568 39.3364 84.1214 36.9883 84.1214 33.8082C84.1214 30.602 81.568 28.2783 78.4314 28.2783ZM78.4314 37.1589C76.7114 37.1589 75.2281 35.776 75.2281 33.8082C75.2281 31.8143 76.7114 30.4558 78.4314 30.4558C80.1497 30.4558 81.6281 31.8143 81.6281 33.8082C81.6281 35.776 80.1497 37.1589 78.4314 37.1589ZM63.6581 29.9732V32.3229H69.4131C69.2447 33.6359 68.7947 34.6012 68.1047 35.2739C67.2647 36.0864 65.9564 36.9883 63.6581 36.9883C60.1164 36.9883 57.3431 34.2014 57.3431 30.7483C57.3431 27.2952 60.1164 24.5083 63.6581 24.5083C65.5731 24.5083 66.9664 25.2379 67.9947 26.1837L69.6931 24.5278C68.2547 23.1888 66.3414 22.1602 63.6581 22.1602C58.8014 22.1602 54.7197 26.013 54.7197 30.7483C54.7197 35.4835 58.8014 39.3364 63.6581 39.3364C66.2831 39.3364 68.2547 38.4979 69.8047 36.9249C71.3931 35.3763 71.8881 33.1988 71.8881 31.4405C71.8881 30.8945 71.8414 30.3924 71.7581 29.9732H63.6581ZM124.068 31.7948C123.6 30.5582 122.155 28.2783 119.211 28.2783C116.295 28.2783 113.866 30.5192 113.866 33.8082C113.866 36.9054 116.27 39.3364 119.491 39.3364C122.096 39.3364 123.6 37.7878 124.218 36.8859L122.285 35.6298C121.64 36.5495 120.761 37.1589 119.491 37.1589C118.23 37.1589 117.325 36.595 116.745 35.4835L124.33 32.4237L124.068 31.7948ZM116.335 33.6359C116.27 31.5039 118.033 30.4119 119.296 30.4119C120.286 30.4119 121.126 30.8945 121.406 31.5852L116.335 33.6359ZM110.17 39H112.663V22.75H110.17V39ZM106.086 29.51H106.003C105.443 28.8633 104.375 28.2783 103.021 28.2783C100.181 28.2783 97.5847 30.7093 97.5847 33.826C97.5847 36.9249 100.181 39.3364 103.021 39.3364C104.375 39.3364 105.443 38.7465 106.003 38.0803H106.086V38.8733C106.086 40.9874 104.928 42.1233 103.06 42.1233C101.536 42.1233 100.591 41.0508 100.201 40.1489L98.033 41.0313C98.658 42.497 100.313 44.3008 103.06 44.3008C105.983 44.3008 108.45 42.6238 108.45 38.5434V28.6147H106.086V29.51ZM103.235 37.1589C101.516 37.1589 100.078 35.7565 100.078 33.826C100.078 31.8777 101.516 30.4558 103.235 30.4558C104.928 30.4558 106.263 31.8777 106.263 33.826C106.263 35.7565 104.928 37.1589 103.235 37.1589ZM135.741 22.75H129.778V39H132.265V32.8429H135.741C138.503 32.8429 141.211 30.8945 141.211 27.7957C141.211 24.6984 138.496 22.75 135.741 22.75ZM135.806 30.5825H132.265V25.0104H135.806C137.663 25.0104 138.723 26.5135 138.723 27.7957C138.723 29.0534 137.663 30.5825 135.806 30.5825ZM151.178 28.2474C149.381 28.2474 147.513 29.0209 146.745 30.7353L148.951 31.6372C149.426 30.7353 150.3 30.4428 151.223 30.4428C152.513 30.4428 153.821 31.1984 153.841 32.5325V32.7032C153.391 32.4497 152.428 32.0743 151.243 32.0743C148.866 32.0743 146.445 33.3499 146.445 35.7305C146.445 37.908 148.391 39.3104 150.58 39.3104C152.253 39.3104 153.176 38.5743 153.756 37.7179H153.841V38.974H156.243V32.7405C156.243 29.8594 154.036 28.2474 151.178 28.2474ZM150.878 37.1524C150.065 37.1524 148.931 36.7592 148.931 35.776C148.931 34.5183 150.345 34.0357 151.568 34.0357C152.663 34.0357 153.176 34.2713 153.841 34.5817C153.646 36.0864 152.318 37.1524 150.878 37.1524ZM164.993 28.6033L162.135 35.6477H162.05L159.095 28.6033H156.413L160.853 38.4475L158.32 43.9254H160.918L167.76 28.6033H164.993ZM142.578 39H145.071V22.75H142.578V39Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_11409",
    x1: 29.0662,
    y1: 40.6775,
    x2: 7.25605,
    y2: 18.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_476_11409",
    x1: 45.1124,
    y1: 25.998,
    x2: 12.8499,
    y2: 25.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_476_11409",
    x1: 33.1024,
    y1: 23.0149,
    x2: 3.52611,
    y2: -7.31976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_476_11409",
    x1: 9.72949,
    y1: 51.7709,
    x2: 22.9366,
    y2: 38.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.22b1b00fdc7e456c3cb30e8db3913451.svg";
export { ForwardRef as ReactComponent };